var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeginnerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bignner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M15 19.3438V5.34375C15 4.79147 15.4477 4.34375 16 4.34375H18C18.5523 4.34375 19 4.79147 19 5.34375V19.3438C19 19.896 18.5523 20.3438 18 20.3438H16C15.4477 20.3438 15 19.896 15 19.3438Z",
    stroke: "#0E9715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M10 19.3438V9.34375C10 8.79147 10.4477 8.34375 11 8.34375H12.5C13.0523 8.34375 13.5 8.79147 13.5 9.34375V19.3438C13.5 19.896 13.0523 20.3438 12.5 20.3438H11C10.4477 20.3438 10 19.896 10 19.3438Z",
    stroke: "#0E9715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M5 19.8438V14.3438C5 13.7915 5.44772 13.3438 6 13.3438H7.5C8.05228 13.3438 8.5 13.7915 8.5 14.3437V19.8438C8.5 20.396 8.05228 20.8438 7.5 20.8438H6C5.44772 20.8438 5 20.396 5 19.8438Z",
    fill: "#0E9715",
    stroke: "#0E9715"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginnerIcon);
export default __webpack_public_path__ + "static/media/beginner-icon.db18c37b3bd36b6bb0de4b716c26bf7c.svg";
export { ForwardRef as ReactComponent };